/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AcknowledgePositionRequest } from '@coin/shared/core/util-models-v2';
import { CommentModel } from '@coin/shared/core/util-models-v2';
import { CreateJobDescription } from '@coin/shared/core/util-models-v2';
import { CreatePositionRequest } from '@coin/shared/core/util-models-v2';
import { CreatePositionRequestComment } from '@coin/shared/core/util-models-v2';
import { CreatePositionRequestDraft } from '@coin/shared/core/util-models-v2';
import { CreatePositionRequestPlan } from '@coin/shared/core/util-models-v2';
import { Dashboard } from '@coin/shared/core/util-models-v2';
import { EmployeesEmployeesEmployee } from '@coin/shared/core/util-models-v2';
import { EnhanceJobDescription } from '@coin/shared/core/util-models-v2';
import { FieldValues } from '@coin/shared/core/util-models-v2';
import { GenerateJobDescription } from '@coin/shared/core/util-models-v2';
import { GeneratedJobDescription } from '@coin/shared/core/util-models-v2';
import { HeadcountApprovalDashboard } from '@coin/shared/core/util-models-v2';
import { HeadcountApprovalPositionSurveyData } from '@coin/shared/core/util-models-v2';
import { JobAd } from '@coin/shared/core/util-models-v2';
import { JobDescription } from '@coin/shared/core/util-models-v2';
import { MercerJobCodeResponse } from '@coin/shared/core/util-models-v2';
import { PageOfCluster } from '@coin/shared/core/util-models-v2';
import { PageOfClusterNode } from '@coin/shared/core/util-models-v2';
import { PageOfCountryClusterNode } from '@coin/shared/core/util-models-v2';
import { PageOfEmployeesEmployeesEmployee } from '@coin/shared/core/util-models-v2';
import { PageOfHeadcountApprovalOrgCode } from '@coin/shared/core/util-models-v2';
import { PageOfMinimalJobDescription } from '@coin/shared/core/util-models-v2';
import { PageOfPositionRequest } from '@coin/shared/core/util-models-v2';
import { PageOfPositionRequestDraft } from '@coin/shared/core/util-models-v2';
import { PageOfReplacementEmployee } from '@coin/shared/core/util-models-v2';
import { PositionRequest } from '@coin/shared/core/util-models-v2';
import { PositionRequestDraft } from '@coin/shared/core/util-models-v2';
import { PositionRequestPlanDashboard } from '@coin/shared/core/util-models-v2';
import { PositionRequestValidationResponse } from '@coin/shared/core/util-models-v2';
import { PrepareJobAd } from '@coin/shared/core/util-models-v2';
import { ReferenceEmployee } from '@coin/shared/core/util-models-v2';
import { ReviewJobAd } from '@coin/shared/core/util-models-v2';
import { ReviewJobAdResult } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfExportStatusMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfJobAdGenerationMetadata } from '@coin/shared/core/util-models-v2';
import { TransferPositionRequest } from '@coin/shared/core/util-models-v2';
import { TranslateJobAd } from '@coin/shared/core/util-models-v2';
import { TranslateJobAdResult } from '@coin/shared/core/util-models-v2';
import { UpdateJobDescription } from '@coin/shared/core/util-models-v2';
import { UpdatePositionRequest } from '@coin/shared/core/util-models-v2';
import { UpdatePositionRequestDraft } from '@coin/shared/core/util-models-v2';
import { UpdatePositionRequestPlan } from '@coin/shared/core/util-models-v2';
import { ValidatePositionRequestInputQuery } from '@coin/shared/core/util-models-v2';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService, RequestArgs, RequestOptions } from '../api.base.service';

export interface AcknowledgePositionRequestsParams {
  /** The unqique id of the position request to acknowledge an approval of. */
  id: string;
  /** The unique id of the approval to acknowledge. */
  approvalId: string;
  /** The date of the last refresh of the requester to be able to assure the request has not been updated in the meantime. */
  ifUnmodifiedSince?: string;
  /** The model data to acknowledge the approval with. */
  acknowledgePositionRequest?: AcknowledgePositionRequest;
}

export interface CreateJobDescriptionsParams {
  /** The model data to create the job description with. */
  createJobDescription?: CreateJobDescription;
}

export interface CreatePositionRequestCommentsParams {
  /** The unique id of the existing position request. */
  positionRequestId: string;
  /** The model data to create the comment with. */
  createPositionRequestComment?: CreatePositionRequestComment;
}

export interface CreatePositionRequestDraftsParams {
  /** The model data to create the position request draft with. */
  createPositionRequestDraft?: CreatePositionRequestDraft;
}

export interface CreatePositionRequestPlanParams {
  /** The model data to create the position request plan with. */
  createPositionRequestPlan?: CreatePositionRequestPlan;
}

export interface CreatePositionRequestsParams {
  /** The model data to create the position request with. */
  createPositionRequest?: CreatePositionRequest;
}

export interface DeletePositionRequestDraftsParams {
  /** The unique id of the position request draft to delete. */
  id: string;
}

export interface DeletePositionRequestPlanParams {
  /** The unique id of the position request plan to delete. */
  id: string;
}

export interface DeletePositionRequestsParams {
  /** The unique id of the position request to delete. */
  id: string;
}

export interface EndJobDescriptionSessionParams {
  sessionId: string;
}

export interface EnhanceJobDescriptionParams {
  enhanceJobDescription?: EnhanceJobDescription;
}

export interface ExportPositionRequestsParams {
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  /** The pending approval step name of the position request. */
  pendingApprovalStepName?: Array<
    | 'Planned'
    | 'Draft'
    | 'Submitted'
    | 'GlobalHrApprover'
    | 'RegionalHrApprover'
    | 'CbApprover'
    | 'NMinusOneApprover'
    | 'NMinusTwoApprover'
    | 'HeadOneApprover'
    | 'HeadTwoApprover'
    | 'HeadNMinusOneApprover'
    | 'HeadNMinusTwoApprover'
    | 'HeadNMinusThreeApprover'
    | 'SelfValidation'
    | 'Approved'
    | 'Rejected'
    | 'Cancelled'
    | 'Vetoed'
    | 'GidApprover'
  >;
  /** The request type of the position request. */
  requestType?: 'Addition' | 'Replacement';
  /** The country geo cluster node ids of the position request. */
  countryGeoClusterNodeId?: Array<string>;
  /** The n-1 level cluster node ids of the position request. */
  nMinusOneLevelClusterNodeId?: Array<string>;
  /** The organization codes of the position request. */
  orgCode?: Array<string>;
  /** The organization codes starts with of the position request. */
  orgCodeStartsWith?: Array<string>;
  /** The location type of the position request. */
  locationType?: 'BestCost' | 'HighCost';
  /** The office types of the position request. */
  officeType?: Array<'CoreOffice' | 'NonCoreOffice'>;
  /** The requester gids of the position request. */
  hiringManagerGid?: Array<string>;
  /** The position classes of the position request. */
  positionClass?: Array<number>;
  /** The organization levels of the position request. */
  orgLevel?: Array<number>;
  /** The position type of the position request. */
  positionType?: 'Head' | 'Employee';
  /** The query type of the position request. */
  queryType?: 'InMyJurisdiction' | 'RequiresMyAction';
  /** The query type of the position request. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** WorkTimeType of the employee. */
  workTimeType?: Array<'Either' | 'FullTime' | 'PartTime'>;
  /** Reference Number in COIN. */
  referenceNumber?: Array<number>;
  /** Legal entity / are code of the position request. */
  areCode?: Array<string>;
  /** Depth Structure of the position request. */
  depthStructure?: Array<string>;
  /** Cost Center of the position request. */
  costCenter?: Array<string>;
  /** Any one of the countries of the position request. */
  country?: Array<string>;
  /** Any one of the regions of the position request. */
  region?: Array<string>;
  /** StartDate of the position request is after this. */
  startDate?: string;
  /** StartDate of the position request is before this. */
  endDate?: string;
  /** The state of the position request export. */
  exportState?: 'Open' | 'Done';
  /** The filename of the position request export. */
  filename?: string;
}

export interface GenerateJobDescriptionParams {
  generateJobDescription?: GenerateJobDescription;
}

export interface GetByIdJobAdsParams {
  /** The ID of the job ad to retrieve. */
  id: string;
}

export interface GetByIdJobDescriptionsParams {
  /** The ID of the job description to retrieve. */
  id: string;
}

export interface GetByIdPositionRequestsParams {
  /** The unique id of the position request. */
  id: string;
}

export interface GetHiringManagersEmployeeMasterDataParams {
  search?: string;
  page?: number;
  size?: number;
}

export interface GetOrganisationHiringManagerOrganisationsParams {
  orgCode: string;
}

export interface GetPositionRequestPlanDashboardParams {
  /** The request type of the position request. */
  requestType?: Array<'Addition' | 'Replacement'>;
  /** The country geo cluster node ids of the position request. */
  countryGeoClusterNodeId?: Array<string>;
  /** The n-1 level cluster node ids of the position request. */
  nMinusOneLevelClusterNodeId?: Array<string>;
  /** The organization codes of the position request. */
  orgCode?: Array<string>;
  /** The organization codes starts with of the position request. */
  orgCodeStartsWith?: string;
  /** The location type of the position request. */
  locationType?: Array<'BestCost' | 'HighCost'>;
  /** The requester gids of the position request. */
  hiringManagerGid?: Array<string>;
  /** The position classes of the position request. */
  positionClass?: Array<number>;
  /** The organization levels of the position request. */
  orgLevel?: Array<number>;
  /** The position type of the position request. */
  positionType?: Array<'Head' | 'Employee'>;
  /** The query type of the position request. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** WorkTimeType of the employee. */
  workTimeType?: Array<'Either' | 'FullTime' | 'PartTime'>;
  /** Legal entity / are code of the position request. */
  areCode?: Array<string>;
  /** Depth Structure of the position request. */
  depthStructure?: Array<string>;
  /** Cost Center of the position request. */
  costCenter?: Array<string>;
  /** Any one of the countries of the position request. */
  country?: Array<string>;
  /** Any one of the regions of the position request. */
  region?: Array<string>;
  /** StartDate of the position request is after this. */
  startDate?: string;
  /** StartDate of the position request is before this. */
  endDate?: string;
}

export interface GetPositionSurveyDataHeadcountApprovalParams {
  /** The organisation\&#39;s code of a position to request survey data for. */
  orgCode: string;
  /** The ISO2 country code of a position to request survey data for. */
  countryIsoAlpha2?: string;
  /** The derived position class of a position to request survey data for. */
  positionClass?: number;
  /** The mercer job code to get matching position survey data for. */
  mercerJobCodeResponse?: MercerJobCodeResponse;
}

export interface GetStatesDashboardPositionRequestsParams {
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  /** The pending approval step name of the position request. */
  pendingApprovalStepName?: Array<
    | 'Planned'
    | 'Draft'
    | 'Submitted'
    | 'GlobalHrApprover'
    | 'RegionalHrApprover'
    | 'CbApprover'
    | 'NMinusOneApprover'
    | 'NMinusTwoApprover'
    | 'HeadOneApprover'
    | 'HeadTwoApprover'
    | 'HeadNMinusOneApprover'
    | 'HeadNMinusTwoApprover'
    | 'HeadNMinusThreeApprover'
    | 'SelfValidation'
    | 'Approved'
    | 'Rejected'
    | 'Cancelled'
    | 'Vetoed'
    | 'GidApprover'
  >;
  /** The request type of the position request. */
  requestType?: 'Addition' | 'Replacement';
  /** The country geo cluster node ids of the position request. */
  countryGeoClusterNodeId?: Array<string>;
  /** The n-1 level cluster node ids of the position request. */
  nMinusOneLevelClusterNodeId?: Array<string>;
  /** The organization codes of the position request. */
  orgCode?: Array<string>;
  /** The organization codes starts with of the position request. */
  orgCodeStartsWith?: Array<string>;
  /** The location type of the position request. */
  locationType?: 'BestCost' | 'HighCost';
  /** The office types of the position request. */
  officeType?: Array<'CoreOffice' | 'NonCoreOffice'>;
  /** The requester gids of the position request. */
  hiringManagerGid?: Array<string>;
  /** The position classes of the position request. */
  positionClass?: Array<number>;
  /** The organization levels of the position request. */
  orgLevel?: Array<number>;
  /** The position type of the position request. */
  positionType?: 'Head' | 'Employee';
  /** The query type of the position request. */
  queryType?: 'InMyJurisdiction' | 'RequiresMyAction';
  /** The query type of the position request. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** WorkTimeType of the employee. */
  workTimeType?: Array<'Either' | 'FullTime' | 'PartTime'>;
  /** Reference Number in COIN. */
  referenceNumber?: Array<number>;
  /** Legal entity / are code of the position request. */
  areCode?: Array<string>;
  /** Depth Structure of the position request. */
  depthStructure?: Array<string>;
  /** Cost Center of the position request. */
  costCenter?: Array<string>;
  /** Any one of the countries of the position request. */
  country?: Array<string>;
  /** Any one of the regions of the position request. */
  region?: Array<string>;
  /** StartDate of the position request is after this. */
  startDate?: string;
  /** StartDate of the position request is before this. */
  endDate?: string;
}

export interface HeadcountApprovalCustomerQueryBusinessAreasBusinessAreasParams {
  /** The search text to compare business areas with. */
  search?: string;
  page?: number;
  size?: number;
}

export interface PagePositionRequestPlanBusinessAreasParams {
  page?: number;
  size?: number;
  /** The search text to compare business areas with. */
  search?: string;
}

export interface PagePositionRequestPlanFieldValuesParams {
  page?: number;
  size?: number;
  /** The request type of the position request. */
  requestType?: string;
  /** The organization codes of the position request. */
  orgCode?: string;
  /** The organization codes starts with of the position request. */
  orgCodeStartsWith?: string;
  /** The location type of the position request. */
  locationType?: string;
  /** The requester gids of the position request. */
  hiringManagerGid?: string;
  /** The position classes of the position request. */
  positionClass?: string;
  /** The organization levels of the position request. */
  orgLevel?: string;
  /** The position type of the position request. */
  positionType?: string;
  /** The query type of the position request. */
  workforceType?: string;
  /** WorkTimeType of the employee. */
  workTimeType?: string;
  /** The property for which to return field-values. */
  targetProperty?:
    | 'RequestType'
    | 'CountryGeoClusterNodeId'
    | 'NMinusOneLevelClusterNodeId'
    | 'OrgCode'
    | 'LocationType'
    | 'HiringManagerGid'
    | 'PositionClass'
    | 'OrgLevel'
    | 'PositionType'
    | 'WorkforceType'
    | 'WorkTimeType'
    | 'AreCode'
    | 'DepthStructure'
    | 'CostCenter'
    | 'Country'
    | 'Region';
}

export interface PagePositionRequestPlanNMinusOneLevelsParams {
  /** The business-area of which to get n-minus-one-levels for. */
  businessAreaId: string;
  /** The search text to compare business areas with. */
  search?: string;
  page?: number;
  size?: number;
}

export interface PagePositionRequestPlanOrgCodesParams {
  /** The search text to compare orgcodes with. */
  search?: string;
  /** The search text orgcodes have to start with. */
  orgCodeStartsWith?: string;
  pagingPage?: number;
  pagingSize?: number;
}

export interface PagePositionRequestPlanReplacementEmployeesParams {
  /** The search text to filter directs with. */
  search?: string;
  page?: number;
  size?: number;
}

export interface PagePositionRequestPlansParams {
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  /** The request type of the position request. */
  requestType?: Array<'Addition' | 'Replacement'>;
  /** The country geo cluster node ids of the position request. */
  countryGeoClusterNodeId?: Array<string>;
  /** The n-1 level cluster node ids of the position request. */
  nMinusOneLevelClusterNodeId?: Array<string>;
  /** The organization codes of the position request. */
  orgCode?: Array<string>;
  /** The organization codes starts with of the position request. */
  orgCodeStartsWith?: string;
  /** The location type of the position request. */
  locationType?: Array<'BestCost' | 'HighCost'>;
  /** The requester gids of the position request. */
  hiringManagerGid?: Array<string>;
  /** The position classes of the position request. */
  positionClass?: Array<number>;
  /** The organization levels of the position request. */
  orgLevel?: Array<number>;
  /** The position type of the position request. */
  positionType?: Array<'Head' | 'Employee'>;
  /** The query type of the position request. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** WorkTimeType of the employee. */
  workTimeType?: Array<'Either' | 'FullTime' | 'PartTime'>;
  /** Legal entity / are code of the position request. */
  areCode?: Array<string>;
  /** Depth Structure of the position request. */
  depthStructure?: Array<string>;
  /** Cost Center of the position request. */
  costCenter?: Array<string>;
  /** Any one of the countries of the position request. */
  country?: Array<string>;
  /** Any one of the regions of the position request. */
  region?: Array<string>;
  /** StartDate of the position request is after this. */
  startDate?: string;
  /** StartDate of the position request is before this. */
  endDate?: string;
}

export interface PagePositionRequestReplacementEmployeesParams {
  /** The search text to filter directs with. */
  search?: string;
  page?: number;
  size?: number;
}

export interface PrepareJobAdsParams {
  /** The position request data, the job description to write the job ads from, and the documents it was generated from. */
  prepareJobAd?: PrepareJobAd;
}

export interface QueryBusinessAreaNMinusOneLevelsBusinessAreasParams {
  businessAreaId: string;
  /** The search text to compare business areas with. */
  search?: string;
  page?: number;
  size?: number;
}

export interface QueryEmployeeMasterDataEmployeeMasterDataParams {
  employeeId: string;
}

export interface QueryFieldValuesPositionRequestsParams {
  /** The target property of the position request field value. */
  targetProperty:
    | 'State'
    | 'PendingApprovalStepName'
    | 'RequestType'
    | 'CountryGeoClusterNodeId'
    | 'NMinusOneLevelClusterNodeId'
    | 'OrgCode'
    | 'LocationType'
    | 'OfficeType'
    | 'HiringManagerGid'
    | 'PositionClass'
    | 'OrgLevel'
    | 'PositionType'
    | 'WorkforceType'
    | 'WorkTimeType'
    | 'ReferenceNumber'
    | 'AreCode'
    | 'DepthStructure'
    | 'CostCenter'
    | 'Country'
    | 'Region';
  pagingPage?: number;
  pagingSize?: number;
  /** The pending approval step name of the position request. */
  pendingApprovalStepName?:
    | 'Planned'
    | 'Draft'
    | 'Submitted'
    | 'GlobalHrApprover'
    | 'RegionalHrApprover'
    | 'CbApprover'
    | 'NMinusOneApprover'
    | 'NMinusTwoApprover'
    | 'HeadOneApprover'
    | 'HeadTwoApprover'
    | 'HeadNMinusOneApprover'
    | 'HeadNMinusTwoApprover'
    | 'HeadNMinusThreeApprover'
    | 'SelfValidation'
    | 'Approved'
    | 'Rejected'
    | 'Cancelled'
    | 'Vetoed'
    | 'GidApprover';
  /** The request type of the position request. */
  requestType?: 'Addition' | 'Replacement';
  /** The country geo cluster node id of the position request. */
  countryGeoClusterNodeId?: string;
  /** The n-1 level cluster node id of the position request. */
  nMinusOneLevelClusterNodeId?: string;
  /** The location type of the position request. */
  locationType?: 'BestCost' | 'HighCost';
  /** The office type of the position request. */
  officeType?: 'CoreOffice' | 'NonCoreOffice';
  /** The requester gid of the position request. */
  hiringManagerGid?: string;
  /** The position class of the position request. */
  positionClass?: number;
  /** The organization code of the position request. */
  orgCode?: string;
  /** The organization level of the position request. */
  orgLevel?: number;
  /** The position type of the position request. */
  positionType?: 'Head' | 'Employee';
  /** The query type of the position request. */
  queryType?: 'InMyJurisdiction' | 'RequiresMyAction';
  /** The workforce type of the position request. */
  workforceType?:
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal';
  /** WorkTimeType of the employee. */
  workTimeType?: 'Either' | 'FullTime' | 'PartTime';
  /** Reference number in COIN. */
  referenceNumber?: number;
  /** Legal entity / are code of the position request. */
  areCode?: string;
  /** Depth Structure of the position request. */
  depthStructure?: string;
  /** Cost Center of the position request. */
  costCenter?: string;
  /** Any one of the countries of the position request. */
  country?: string;
  /** Any one of the regions of the position request. */
  region?: string;
}

export interface QueryJobDescriptionsParams {
  /** The organisational code. */
  orgCode: string;
  /** The unique id of the job code (from Mercer). */
  jobCodeId?: string;
  /** The search text to search the title */
  search?: string;
  page?: number;
  size?: number;
}

export interface QueryOrgCodesHeadcountApprovalParams {
  /** The search text to compare orgcodes with. */
  search?: string;
  /** The search text orgcodes have to start with. */
  orgCodeStartsWith?: string;
  pagingPage?: number;
  pagingSize?: number;
}

export interface QueryPositionRequestCommentsParams {
  /** The unique id of the position request to return comments of. */
  positionRequestId: string;
}

export interface QueryPositionRequestsParams {
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  /** The pending approval step name of the position request. */
  pendingApprovalStepName?: Array<
    | 'Planned'
    | 'Draft'
    | 'Submitted'
    | 'GlobalHrApprover'
    | 'RegionalHrApprover'
    | 'CbApprover'
    | 'NMinusOneApprover'
    | 'NMinusTwoApprover'
    | 'HeadOneApprover'
    | 'HeadTwoApprover'
    | 'HeadNMinusOneApprover'
    | 'HeadNMinusTwoApprover'
    | 'HeadNMinusThreeApprover'
    | 'SelfValidation'
    | 'Approved'
    | 'Rejected'
    | 'Cancelled'
    | 'Vetoed'
    | 'GidApprover'
  >;
  /** The request type of the position request. */
  requestType?: 'Addition' | 'Replacement';
  /** The country geo cluster node ids of the position request. */
  countryGeoClusterNodeId?: Array<string>;
  /** The n-1 level cluster node ids of the position request. */
  nMinusOneLevelClusterNodeId?: Array<string>;
  /** The organization codes of the position request. */
  orgCode?: Array<string>;
  /** The organization codes starts with of the position request. */
  orgCodeStartsWith?: Array<string>;
  /** The location type of the position request. */
  locationType?: 'BestCost' | 'HighCost';
  /** The office types of the position request. */
  officeType?: Array<'CoreOffice' | 'NonCoreOffice'>;
  /** The requester gids of the position request. */
  hiringManagerGid?: Array<string>;
  /** The position classes of the position request. */
  positionClass?: Array<number>;
  /** The organization levels of the position request. */
  orgLevel?: Array<number>;
  /** The position type of the position request. */
  positionType?: 'Head' | 'Employee';
  /** The query type of the position request. */
  queryType?: 'InMyJurisdiction' | 'RequiresMyAction';
  /** The query type of the position request. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** WorkTimeType of the employee. */
  workTimeType?: Array<'Either' | 'FullTime' | 'PartTime'>;
  /** Reference Number in COIN. */
  referenceNumber?: Array<number>;
  /** Legal entity / are code of the position request. */
  areCode?: Array<string>;
  /** Depth Structure of the position request. */
  depthStructure?: Array<string>;
  /** Cost Center of the position request. */
  costCenter?: Array<string>;
  /** Any one of the countries of the position request. */
  country?: Array<string>;
  /** Any one of the regions of the position request. */
  region?: Array<string>;
  /** StartDate of the position request is after this. */
  startDate?: string;
  /** StartDate of the position request is before this. */
  endDate?: string;
}

export interface QueryReferenceEmployeesEmployeeMasterDataParams {
  orgCode: string;
  search?: string;
}

export interface QueryRegionCountriesCountriesParams {
  /** The search text to compare business areas with. */
  search?: string;
  regionIds?: Array<string>;
  page?: number;
  size?: number;
}

export interface QueryRegionsRegionsParams {
  /** The search text to compare regions with. */
  search?: string;
  page?: number;
  size?: number;
}

export interface ReviewJobAdsParams {
  /** The resolved template, the job ad to check, and the job description it was written from. */
  reviewJobAd?: ReviewJobAd;
}

export interface TransferPositionRequestParams {
  /** The unique id of the position request to transfer. */
  id: string;
  /** The model data containing the target organization and optional new start date. */
  transferPositionRequest?: TransferPositionRequest;
}

export interface TranslateJobAdsParams {
  /** The resolved template, the job ad to translate, and the language to add. */
  translateJobAd?: TranslateJobAd;
}

export interface UpdateJobDescriptionsParams {
  /** The ID of the job description to update. */
  id: string;
  /** The updated job description data. */
  updateJobDescription?: UpdateJobDescription;
}

export interface UpdatePositionRequestDraftsParams {
  /** The unique id of the position request draft to update. */
  id: string;
  /** The model data to update the existing position request draft with. */
  updatePositionRequestDraft?: UpdatePositionRequestDraft;
}

export interface UpdatePositionRequestPlanParams {
  /** The unique id of the position request plan to update. */
  id: string;
  /** The model data to update the existing position request plan with. */
  updatePositionRequestPlan?: UpdatePositionRequestPlan;
}

export interface UpdatePositionRequestsParams {
  /** The unique id of the position request to update (or the unique id of the draft to create the position request from). */
  id: string;
  /** The model data to update an existing position request with (or the model data to create a new position request from a position request draft). */
  updatePositionRequest?: UpdatePositionRequest;
}

export interface ValidatePositionRequestsParams {
  /** The position request input to validate. */
  validatePositionRequestInputQuery?: ValidatePositionRequestInputQuery;
}

export interface VetoPositionRequestsParams {
  /** The unique id of the position request to veto. */
  id: string;
}

@Injectable({
  providedIn: 'root'
})
export class HeadcountApprovalCustomerService extends BaseService {
  constructor(
    httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    super(httpClient, basePath, configuration);
  }

  /**
   * Acknowledges a specific, existing approval of an existing position request by their unique ids.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public acknowledgePositionRequests(
    requestParameters?: AcknowledgePositionRequestsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PositionRequest>;
  public acknowledgePositionRequests(
    requestParameters?: AcknowledgePositionRequestsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PositionRequest>>;
  public acknowledgePositionRequests(
    requestParameters?: AcknowledgePositionRequestsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PositionRequest>>;
  public acknowledgePositionRequests(
    requestParameters?: AcknowledgePositionRequestsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const approvalId = requestParameters?.approvalId;
    this.checkRequired('acknowledgePositionRequests', { id, approvalId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/customer/api/v1/master/positions/requests/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/approvals/${this.configuration.encodeParam({ name: 'approvalId', value: approvalId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/acknowledge`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      headers: { 'If-Unmodified-Since': requestParameters?.ifUnmodifiedSince },
      body: requestParameters?.acknowledgePositionRequest,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Creates a new job description.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createJobDescriptions(
    requestParameters?: CreateJobDescriptionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<JobDescription>;
  public createJobDescriptions(
    requestParameters?: CreateJobDescriptionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<JobDescription>>;
  public createJobDescriptions(
    requestParameters?: CreateJobDescriptionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<JobDescription>>;
  public createJobDescriptions(requestParameters?: CreateJobDescriptionsParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/customer/api/v1/master/job-descriptions`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createJobDescription,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Creates a new comment for an existing position request.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createPositionRequestComments(
    requestParameters?: CreatePositionRequestCommentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<CommentModel>;
  public createPositionRequestComments(
    requestParameters?: CreatePositionRequestCommentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<CommentModel>>;
  public createPositionRequestComments(
    requestParameters?: CreatePositionRequestCommentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<CommentModel>>;
  public createPositionRequestComments(
    requestParameters?: CreatePositionRequestCommentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const positionRequestId = requestParameters?.positionRequestId;
    this.checkRequired('createPositionRequestComments', { positionRequestId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/customer/api/v1/master/positions/requests/${this.configuration.encodeParam({ name: 'positionRequestId', value: positionRequestId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/comments`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createPositionRequestComment,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Creates a new position request draft.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createPositionRequestDrafts(
    requestParameters?: CreatePositionRequestDraftsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PositionRequestDraft>;
  public createPositionRequestDrafts(
    requestParameters?: CreatePositionRequestDraftsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PositionRequestDraft>>;
  public createPositionRequestDrafts(
    requestParameters?: CreatePositionRequestDraftsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PositionRequestDraft>>;
  public createPositionRequestDrafts(
    requestParameters?: CreatePositionRequestDraftsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/customer/api/v1/master/positions/requests/drafts`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createPositionRequestDraft,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Creates a new position request plan.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createPositionRequestPlan(
    requestParameters?: CreatePositionRequestPlanParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PositionRequestDraft>;
  public createPositionRequestPlan(
    requestParameters?: CreatePositionRequestPlanParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PositionRequestDraft>>;
  public createPositionRequestPlan(
    requestParameters?: CreatePositionRequestPlanParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PositionRequestDraft>>;
  public createPositionRequestPlan(
    requestParameters?: CreatePositionRequestPlanParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/customer/api/v1/master/positions/requests/plans`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createPositionRequestPlan,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Creates a new position request.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createPositionRequests(
    requestParameters?: CreatePositionRequestsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PositionRequest>;
  public createPositionRequests(
    requestParameters?: CreatePositionRequestsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PositionRequest>>;
  public createPositionRequests(
    requestParameters?: CreatePositionRequestsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PositionRequest>>;
  public createPositionRequests(
    requestParameters?: CreatePositionRequestsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/customer/api/v1/master/positions/requests`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createPositionRequest,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Deletes an existing position request draft by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deletePositionRequestDrafts(
    requestParameters?: DeletePositionRequestDraftsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public deletePositionRequestDrafts(
    requestParameters?: DeletePositionRequestDraftsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public deletePositionRequestDrafts(
    requestParameters?: DeletePositionRequestDraftsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public deletePositionRequestDrafts(
    requestParameters?: DeletePositionRequestDraftsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('deletePositionRequestDrafts', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/customer/api/v1/master/positions/requests/drafts/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: []
    });
  }

  /**
   * Deletes an existing position request plan by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deletePositionRequestPlan(
    requestParameters?: DeletePositionRequestPlanParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public deletePositionRequestPlan(
    requestParameters?: DeletePositionRequestPlanParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public deletePositionRequestPlan(
    requestParameters?: DeletePositionRequestPlanParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public deletePositionRequestPlan(
    requestParameters?: DeletePositionRequestPlanParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('deletePositionRequestPlan', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/customer/api/v1/master/positions/requests/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: []
    });
  }

  /**
   * Deletes an existing position request by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deletePositionRequests(
    requestParameters?: DeletePositionRequestsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public deletePositionRequests(
    requestParameters?: DeletePositionRequestsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public deletePositionRequests(
    requestParameters?: DeletePositionRequestsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public deletePositionRequests(
    requestParameters?: DeletePositionRequestsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('deletePositionRequests', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/customer/api/v1/master/positions/requests/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: []
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public endJobDescriptionSession(
    requestParameters?: EndJobDescriptionSessionParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public endJobDescriptionSession(
    requestParameters?: EndJobDescriptionSessionParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public endJobDescriptionSession(
    requestParameters?: EndJobDescriptionSessionParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public endJobDescriptionSession(
    requestParameters?: EndJobDescriptionSessionParams,
    ...args: RequestArgs
  ): Observable<any> {
    const sessionId = requestParameters?.sessionId;
    this.checkRequired('endJobDescriptionSession', { sessionId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/customer/api/v1/master/headcount-approval/job-description/sessions/${this.configuration.encodeParam({ name: 'sessionId', value: sessionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`,
      accepts: []
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public enhanceJobDescription(
    requestParameters?: EnhanceJobDescriptionParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<GeneratedJobDescription>;
  public enhanceJobDescription(
    requestParameters?: EnhanceJobDescriptionParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<GeneratedJobDescription>>;
  public enhanceJobDescription(
    requestParameters?: EnhanceJobDescriptionParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<GeneratedJobDescription>>;
  public enhanceJobDescription(requestParameters?: EnhanceJobDescriptionParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/customer/api/v1/master/headcount-approval/job-description/enhancement`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.enhanceJobDescription,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Exports existing position requests by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportPositionRequests(
    requestParameters?: ExportPositionRequestsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportPositionRequests(
    requestParameters?: ExportPositionRequestsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportPositionRequests(
    requestParameters?: ExportPositionRequestsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportPositionRequests(
    requestParameters?: ExportPositionRequestsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/customer/api/v1/master/positions/requests/export`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        PendingApprovalStepName: requestParameters?.pendingApprovalStepName,
        RequestType: requestParameters?.requestType,
        CountryGeoClusterNodeId: requestParameters?.countryGeoClusterNodeId,
        NMinusOneLevelClusterNodeId: requestParameters?.nMinusOneLevelClusterNodeId,
        OrgCode: requestParameters?.orgCode,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        LocationType: requestParameters?.locationType,
        OfficeType: requestParameters?.officeType,
        HiringManagerGid: requestParameters?.hiringManagerGid,
        PositionClass: requestParameters?.positionClass,
        OrgLevel: requestParameters?.orgLevel,
        PositionType: requestParameters?.positionType,
        QueryType: requestParameters?.queryType,
        WorkforceType: requestParameters?.workforceType,
        WorkTimeType: requestParameters?.workTimeType,
        ReferenceNumber: requestParameters?.referenceNumber,
        AreCode: requestParameters?.areCode,
        DepthStructure: requestParameters?.depthStructure,
        CostCenter: requestParameters?.costCenter,
        Country: requestParameters?.country,
        Region: requestParameters?.region,
        StartDate: requestParameters?.startDate,
        EndDate: requestParameters?.endDate,
        ExportState: requestParameters?.exportState,
        Filename: requestParameters?.filename
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public generateJobDescription(
    requestParameters?: GenerateJobDescriptionParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<GeneratedJobDescription>;
  public generateJobDescription(
    requestParameters?: GenerateJobDescriptionParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<GeneratedJobDescription>>;
  public generateJobDescription(
    requestParameters?: GenerateJobDescriptionParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<GeneratedJobDescription>>;
  public generateJobDescription(
    requestParameters?: GenerateJobDescriptionParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/customer/api/v1/master/headcount-approval/job-description/generation`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.generateJobDescription,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Gets a job ad by its ID.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getByIdJobAds(
    requestParameters?: GetByIdJobAdsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<JobAd>;
  public getByIdJobAds(
    requestParameters?: GetByIdJobAdsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<JobAd>>;
  public getByIdJobAds(
    requestParameters?: GetByIdJobAdsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<JobAd>>;
  public getByIdJobAds(requestParameters?: GetByIdJobAdsParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('getByIdJobAds', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/api/v1/master/job-ads/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Gets a job description by its ID.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getByIdJobDescriptions(
    requestParameters?: GetByIdJobDescriptionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<JobDescription>;
  public getByIdJobDescriptions(
    requestParameters?: GetByIdJobDescriptionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<JobDescription>>;
  public getByIdJobDescriptions(
    requestParameters?: GetByIdJobDescriptionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<JobDescription>>;
  public getByIdJobDescriptions(
    requestParameters?: GetByIdJobDescriptionsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('getByIdJobDescriptions', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/api/v1/master/job-descriptions/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Gets an existing position request by its id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getByIdPositionRequests(
    requestParameters?: GetByIdPositionRequestsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PositionRequest>;
  public getByIdPositionRequests(
    requestParameters?: GetByIdPositionRequestsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PositionRequest>>;
  public getByIdPositionRequests(
    requestParameters?: GetByIdPositionRequestsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PositionRequest>>;
  public getByIdPositionRequests(
    requestParameters?: GetByIdPositionRequestsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('getByIdPositionRequests', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/api/v1/master/positions/requests/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Gets the headcount approval dashboard values.
   * Values are shown in Frontend when initially opening headcount approval. They provide a quick overview of position requests the current user has access to or is involved in.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDashboardHeadcountApproval(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HeadcountApprovalDashboard>;
  public getDashboardHeadcountApproval(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<HeadcountApprovalDashboard>>;
  public getDashboardHeadcountApproval(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<HeadcountApprovalDashboard>>;
  public getDashboardHeadcountApproval(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/api/v1/master/headcount-approval/dashboard`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getHiringManagersEmployeeMasterData(
    requestParameters?: GetHiringManagersEmployeeMasterDataParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEmployeesEmployeesEmployee>;
  public getHiringManagersEmployeeMasterData(
    requestParameters?: GetHiringManagersEmployeeMasterDataParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEmployeesEmployeesEmployee>>;
  public getHiringManagersEmployeeMasterData(
    requestParameters?: GetHiringManagersEmployeeMasterDataParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEmployeesEmployeesEmployee>>;
  public getHiringManagersEmployeeMasterData(
    requestParameters?: GetHiringManagersEmployeeMasterDataParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/api/v1/master/headcount-approval/employee/hiring-managers`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { search: requestParameters?.search, Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getOrganisationHiringManagerOrganisations(
    requestParameters?: GetOrganisationHiringManagerOrganisationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EmployeesEmployeesEmployee>;
  public getOrganisationHiringManagerOrganisations(
    requestParameters?: GetOrganisationHiringManagerOrganisationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EmployeesEmployeesEmployee>>;
  public getOrganisationHiringManagerOrganisations(
    requestParameters?: GetOrganisationHiringManagerOrganisationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EmployeesEmployeesEmployee>>;
  public getOrganisationHiringManagerOrganisations(
    requestParameters?: GetOrganisationHiringManagerOrganisationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const orgCode = requestParameters?.orgCode;
    this.checkRequired('getOrganisationHiringManagerOrganisations', { orgCode });
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/api/v1/master/headcount-approval/organisations/${this.configuration.encodeParam({ name: 'orgCode', value: orgCode, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/hiring-manager`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Gets a dashboard overview of counts of position request plans.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPositionRequestPlanDashboard(
    requestParameters?: GetPositionRequestPlanDashboardParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PositionRequestPlanDashboard>;
  public getPositionRequestPlanDashboard(
    requestParameters?: GetPositionRequestPlanDashboardParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PositionRequestPlanDashboard>>;
  public getPositionRequestPlanDashboard(
    requestParameters?: GetPositionRequestPlanDashboardParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PositionRequestPlanDashboard>>;
  public getPositionRequestPlanDashboard(
    requestParameters?: GetPositionRequestPlanDashboardParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/api/v1/master/positions/requests/plan/dashboard`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        RequestType: requestParameters?.requestType,
        CountryGeoClusterNodeId: requestParameters?.countryGeoClusterNodeId,
        NMinusOneLevelClusterNodeId: requestParameters?.nMinusOneLevelClusterNodeId,
        OrgCode: requestParameters?.orgCode,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        LocationType: requestParameters?.locationType,
        HiringManagerGid: requestParameters?.hiringManagerGid,
        PositionClass: requestParameters?.positionClass,
        OrgLevel: requestParameters?.orgLevel,
        PositionType: requestParameters?.positionType,
        WorkforceType: requestParameters?.workforceType,
        WorkTimeType: requestParameters?.workTimeType,
        AreCode: requestParameters?.areCode,
        DepthStructure: requestParameters?.depthStructure,
        CostCenter: requestParameters?.costCenter,
        Country: requestParameters?.country,
        Region: requestParameters?.region,
        StartDate: requestParameters?.startDate,
        EndDate: requestParameters?.endDate
      }
    });
  }

  /**
   * Gets (generates) position survey data for provided query data.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPositionSurveyDataHeadcountApproval(
    requestParameters?: GetPositionSurveyDataHeadcountApprovalParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HeadcountApprovalPositionSurveyData>;
  public getPositionSurveyDataHeadcountApproval(
    requestParameters?: GetPositionSurveyDataHeadcountApprovalParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<HeadcountApprovalPositionSurveyData>>;
  public getPositionSurveyDataHeadcountApproval(
    requestParameters?: GetPositionSurveyDataHeadcountApprovalParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<HeadcountApprovalPositionSurveyData>>;
  public getPositionSurveyDataHeadcountApproval(
    requestParameters?: GetPositionSurveyDataHeadcountApprovalParams,
    ...args: RequestArgs
  ): Observable<any> {
    const orgCode = requestParameters?.orgCode;
    this.checkRequired('getPositionSurveyDataHeadcountApproval', { orgCode });
    return this.sendRequest(args, {
      method: 'post',
      path: `/customer/api/v1/master/headcount-approval/position-survey-data`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        OrgCode: orgCode,
        CountryIsoAlpha2: requestParameters?.countryIsoAlpha2,
        PositionClass: requestParameters?.positionClass
      },
      body: requestParameters?.mercerJobCodeResponse,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Gets a dashboard overview of counts of found position requests grouped into states.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getStatesDashboardPositionRequests(
    requestParameters?: GetStatesDashboardPositionRequestsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Dashboard>;
  public getStatesDashboardPositionRequests(
    requestParameters?: GetStatesDashboardPositionRequestsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Dashboard>>;
  public getStatesDashboardPositionRequests(
    requestParameters?: GetStatesDashboardPositionRequestsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Dashboard>>;
  public getStatesDashboardPositionRequests(
    requestParameters?: GetStatesDashboardPositionRequestsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/api/v1/master/positions/requests/dashboard`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        PendingApprovalStepName: requestParameters?.pendingApprovalStepName,
        RequestType: requestParameters?.requestType,
        CountryGeoClusterNodeId: requestParameters?.countryGeoClusterNodeId,
        NMinusOneLevelClusterNodeId: requestParameters?.nMinusOneLevelClusterNodeId,
        OrgCode: requestParameters?.orgCode,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        LocationType: requestParameters?.locationType,
        OfficeType: requestParameters?.officeType,
        HiringManagerGid: requestParameters?.hiringManagerGid,
        PositionClass: requestParameters?.positionClass,
        OrgLevel: requestParameters?.orgLevel,
        PositionType: requestParameters?.positionType,
        QueryType: requestParameters?.queryType,
        WorkforceType: requestParameters?.workforceType,
        WorkTimeType: requestParameters?.workTimeType,
        ReferenceNumber: requestParameters?.referenceNumber,
        AreCode: requestParameters?.areCode,
        DepthStructure: requestParameters?.depthStructure,
        CostCenter: requestParameters?.costCenter,
        Country: requestParameters?.country,
        Region: requestParameters?.region,
        StartDate: requestParameters?.startDate,
        EndDate: requestParameters?.endDate
      }
    });
  }

  /**
   * Queries existing business areas by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public headcountApprovalCustomerQueryBusinessAreasBusinessAreas(
    requestParameters?: HeadcountApprovalCustomerQueryBusinessAreasBusinessAreasParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfCluster>;
  public headcountApprovalCustomerQueryBusinessAreasBusinessAreas(
    requestParameters?: HeadcountApprovalCustomerQueryBusinessAreasBusinessAreasParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfCluster>>;
  public headcountApprovalCustomerQueryBusinessAreasBusinessAreas(
    requestParameters?: HeadcountApprovalCustomerQueryBusinessAreasBusinessAreasParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfCluster>>;
  public headcountApprovalCustomerQueryBusinessAreasBusinessAreas(
    requestParameters?: HeadcountApprovalCustomerQueryBusinessAreasBusinessAreasParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/api/v1/master/headcount-approval/business-areas`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Search: requestParameters?.search, Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * Queries position request plan business-areas of the current user by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pagePositionRequestPlanBusinessAreas(
    requestParameters?: PagePositionRequestPlanBusinessAreasParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfCluster>;
  public pagePositionRequestPlanBusinessAreas(
    requestParameters?: PagePositionRequestPlanBusinessAreasParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfCluster>>;
  public pagePositionRequestPlanBusinessAreas(
    requestParameters?: PagePositionRequestPlanBusinessAreasParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfCluster>>;
  public pagePositionRequestPlanBusinessAreas(
    requestParameters?: PagePositionRequestPlanBusinessAreasParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/api/v1/master/positions/requests/plan/business-areas`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size, Search: requestParameters?.search }
    });
  }

  /**
   * Queries position request plan field values of the current user by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pagePositionRequestPlanFieldValues(
    requestParameters?: PagePositionRequestPlanFieldValuesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<FieldValues>;
  public pagePositionRequestPlanFieldValues(
    requestParameters?: PagePositionRequestPlanFieldValuesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<FieldValues>>;
  public pagePositionRequestPlanFieldValues(
    requestParameters?: PagePositionRequestPlanFieldValuesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<FieldValues>>;
  public pagePositionRequestPlanFieldValues(
    requestParameters?: PagePositionRequestPlanFieldValuesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/api/v1/master/positions/requests/plan/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        RequestType: requestParameters?.requestType,
        OrgCode: requestParameters?.orgCode,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        LocationType: requestParameters?.locationType,
        HiringManagerGid: requestParameters?.hiringManagerGid,
        PositionClass: requestParameters?.positionClass,
        OrgLevel: requestParameters?.orgLevel,
        PositionType: requestParameters?.positionType,
        WorkforceType: requestParameters?.workforceType,
        WorkTimeType: requestParameters?.workTimeType,
        targetProperty: requestParameters?.targetProperty
      }
    });
  }

  /**
   * Queries existing n-1 levels of a business area by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pagePositionRequestPlanNMinusOneLevels(
    requestParameters?: PagePositionRequestPlanNMinusOneLevelsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfClusterNode>;
  public pagePositionRequestPlanNMinusOneLevels(
    requestParameters?: PagePositionRequestPlanNMinusOneLevelsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfClusterNode>>;
  public pagePositionRequestPlanNMinusOneLevels(
    requestParameters?: PagePositionRequestPlanNMinusOneLevelsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfClusterNode>>;
  public pagePositionRequestPlanNMinusOneLevels(
    requestParameters?: PagePositionRequestPlanNMinusOneLevelsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const businessAreaId = requestParameters?.businessAreaId;
    this.checkRequired('pagePositionRequestPlanNMinusOneLevels', { businessAreaId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/api/v1/master/positions/requests/plan/business-areas/${this.configuration.encodeParam({ name: 'businessAreaId', value: businessAreaId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/n-minus-one-levels`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Search: requestParameters?.search, Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * Gets all orgcodes and their assigned level the headcount approval process has access to.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pagePositionRequestPlanOrgCodes(
    requestParameters?: PagePositionRequestPlanOrgCodesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfHeadcountApprovalOrgCode>;
  public pagePositionRequestPlanOrgCodes(
    requestParameters?: PagePositionRequestPlanOrgCodesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfHeadcountApprovalOrgCode>>;
  public pagePositionRequestPlanOrgCodes(
    requestParameters?: PagePositionRequestPlanOrgCodesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfHeadcountApprovalOrgCode>>;
  public pagePositionRequestPlanOrgCodes(
    requestParameters?: PagePositionRequestPlanOrgCodesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/api/v1/master/positions/requests/plan/org-codes`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Search: requestParameters?.search,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize
      }
    });
  }

  /**
   * Queries all available replacement employees for a planned position.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pagePositionRequestPlanReplacementEmployees(
    requestParameters?: PagePositionRequestPlanReplacementEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfReplacementEmployee>;
  public pagePositionRequestPlanReplacementEmployees(
    requestParameters?: PagePositionRequestPlanReplacementEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfReplacementEmployee>>;
  public pagePositionRequestPlanReplacementEmployees(
    requestParameters?: PagePositionRequestPlanReplacementEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfReplacementEmployee>>;
  public pagePositionRequestPlanReplacementEmployees(
    requestParameters?: PagePositionRequestPlanReplacementEmployeesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/api/v1/master/positions/requests/plan/replacement`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Search: requestParameters?.search, Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * Queries existing position request plans of the current user by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pagePositionRequestPlans(
    requestParameters?: PagePositionRequestPlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfPositionRequestDraft>;
  public pagePositionRequestPlans(
    requestParameters?: PagePositionRequestPlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfPositionRequestDraft>>;
  public pagePositionRequestPlans(
    requestParameters?: PagePositionRequestPlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfPositionRequestDraft>>;
  public pagePositionRequestPlans(
    requestParameters?: PagePositionRequestPlansParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/api/v1/master/positions/requests/plans`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property,
        RequestType: requestParameters?.requestType,
        CountryGeoClusterNodeId: requestParameters?.countryGeoClusterNodeId,
        NMinusOneLevelClusterNodeId: requestParameters?.nMinusOneLevelClusterNodeId,
        OrgCode: requestParameters?.orgCode,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        LocationType: requestParameters?.locationType,
        HiringManagerGid: requestParameters?.hiringManagerGid,
        PositionClass: requestParameters?.positionClass,
        OrgLevel: requestParameters?.orgLevel,
        PositionType: requestParameters?.positionType,
        WorkforceType: requestParameters?.workforceType,
        WorkTimeType: requestParameters?.workTimeType,
        AreCode: requestParameters?.areCode,
        DepthStructure: requestParameters?.depthStructure,
        CostCenter: requestParameters?.costCenter,
        Country: requestParameters?.country,
        Region: requestParameters?.region,
        StartDate: requestParameters?.startDate,
        EndDate: requestParameters?.endDate
      }
    });
  }

  /**
   * Queries all available replacement employees.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pagePositionRequestReplacementEmployees(
    requestParameters?: PagePositionRequestReplacementEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfReplacementEmployee>;
  public pagePositionRequestReplacementEmployees(
    requestParameters?: PagePositionRequestReplacementEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfReplacementEmployee>>;
  public pagePositionRequestReplacementEmployees(
    requestParameters?: PagePositionRequestReplacementEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfReplacementEmployee>>;
  public pagePositionRequestReplacementEmployees(
    requestParameters?: PagePositionRequestReplacementEmployeesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/api/v1/master/positions/requests/replacement`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Search: requestParameters?.search, Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * Prepares the job ads with their matching template for the given position request data
   * A job ad can be written from an uploaded document as well: send the same &#x60;jobDescriptionAttachmentIds&#x60; that were sent to the job description generation, and the documents behind them go to the agent along with the job description that was distilled from them. Nothing is uploaded here — the files are already stored under those ids.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public prepareJobAds(
    requestParameters?: PrepareJobAdsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfJobAdGenerationMetadata>;
  public prepareJobAds(
    requestParameters?: PrepareJobAdsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfJobAdGenerationMetadata>>;
  public prepareJobAds(
    requestParameters?: PrepareJobAdsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfJobAdGenerationMetadata>>;
  public prepareJobAds(requestParameters?: PrepareJobAdsParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/customer/api/v1/master/job-ads/prepare`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.prepareJobAd,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Queries existing n-1 levels of a business area areas by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryBusinessAreaNMinusOneLevelsBusinessAreas(
    requestParameters?: QueryBusinessAreaNMinusOneLevelsBusinessAreasParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfClusterNode>;
  public queryBusinessAreaNMinusOneLevelsBusinessAreas(
    requestParameters?: QueryBusinessAreaNMinusOneLevelsBusinessAreasParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfClusterNode>>;
  public queryBusinessAreaNMinusOneLevelsBusinessAreas(
    requestParameters?: QueryBusinessAreaNMinusOneLevelsBusinessAreasParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfClusterNode>>;
  public queryBusinessAreaNMinusOneLevelsBusinessAreas(
    requestParameters?: QueryBusinessAreaNMinusOneLevelsBusinessAreasParams,
    ...args: RequestArgs
  ): Observable<any> {
    const businessAreaId = requestParameters?.businessAreaId;
    this.checkRequired('queryBusinessAreaNMinusOneLevelsBusinessAreas', { businessAreaId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/api/v1/master/headcount-approval/business-areas/${this.configuration.encodeParam({ name: 'businessAreaId', value: businessAreaId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/n-minus-one-levels`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Search: requestParameters?.search, Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryEmployeeMasterDataEmployeeMasterData(
    requestParameters?: QueryEmployeeMasterDataEmployeeMasterDataParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ReferenceEmployee>;
  public queryEmployeeMasterDataEmployeeMasterData(
    requestParameters?: QueryEmployeeMasterDataEmployeeMasterDataParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ReferenceEmployee>>;
  public queryEmployeeMasterDataEmployeeMasterData(
    requestParameters?: QueryEmployeeMasterDataEmployeeMasterDataParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ReferenceEmployee>>;
  public queryEmployeeMasterDataEmployeeMasterData(
    requestParameters?: QueryEmployeeMasterDataEmployeeMasterDataParams,
    ...args: RequestArgs
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('queryEmployeeMasterDataEmployeeMasterData', { employeeId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/api/v1/master/headcount-approval/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Queries position request field values by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesPositionRequests(
    requestParameters?: QueryFieldValuesPositionRequestsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<FieldValues>;
  public queryFieldValuesPositionRequests(
    requestParameters?: QueryFieldValuesPositionRequestsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<FieldValues>>;
  public queryFieldValuesPositionRequests(
    requestParameters?: QueryFieldValuesPositionRequestsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<FieldValues>>;
  public queryFieldValuesPositionRequests(
    requestParameters?: QueryFieldValuesPositionRequestsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const targetProperty = requestParameters?.targetProperty;
    this.checkRequired('queryFieldValuesPositionRequests', { targetProperty });
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/api/v1/master/positions/requests/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: targetProperty,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        PendingApprovalStepName: requestParameters?.pendingApprovalStepName,
        RequestType: requestParameters?.requestType,
        CountryGeoClusterNodeId: requestParameters?.countryGeoClusterNodeId,
        NMinusOneLevelClusterNodeId: requestParameters?.nMinusOneLevelClusterNodeId,
        LocationType: requestParameters?.locationType,
        OfficeType: requestParameters?.officeType,
        HiringManagerGid: requestParameters?.hiringManagerGid,
        PositionClass: requestParameters?.positionClass,
        OrgCode: requestParameters?.orgCode,
        OrgLevel: requestParameters?.orgLevel,
        PositionType: requestParameters?.positionType,
        QueryType: requestParameters?.queryType,
        WorkforceType: requestParameters?.workforceType,
        WorkTimeType: requestParameters?.workTimeType,
        ReferenceNumber: requestParameters?.referenceNumber,
        AreCode: requestParameters?.areCode,
        DepthStructure: requestParameters?.depthStructure,
        CostCenter: requestParameters?.costCenter,
        Country: requestParameters?.country,
        Region: requestParameters?.region
      }
    });
  }

  /**
   * Query job descriptions and job ads based on input
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryJobDescriptions(
    requestParameters?: QueryJobDescriptionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfMinimalJobDescription>;
  public queryJobDescriptions(
    requestParameters?: QueryJobDescriptionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfMinimalJobDescription>>;
  public queryJobDescriptions(
    requestParameters?: QueryJobDescriptionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfMinimalJobDescription>>;
  public queryJobDescriptions(requestParameters?: QueryJobDescriptionsParams, ...args: RequestArgs): Observable<any> {
    const orgCode = requestParameters?.orgCode;
    this.checkRequired('queryJobDescriptions', { orgCode });
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/api/v1/master/job-descriptions`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        OrgCode: orgCode,
        JobCodeId: requestParameters?.jobCodeId,
        Search: requestParameters?.search,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * Gets all orgcodes and their assigned level the headcount approval process has access to.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryOrgCodesHeadcountApproval(
    requestParameters?: QueryOrgCodesHeadcountApprovalParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfHeadcountApprovalOrgCode>;
  public queryOrgCodesHeadcountApproval(
    requestParameters?: QueryOrgCodesHeadcountApprovalParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfHeadcountApprovalOrgCode>>;
  public queryOrgCodesHeadcountApproval(
    requestParameters?: QueryOrgCodesHeadcountApprovalParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfHeadcountApprovalOrgCode>>;
  public queryOrgCodesHeadcountApproval(
    requestParameters?: QueryOrgCodesHeadcountApprovalParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/api/v1/master/headcount-approval/org-codes`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Search: requestParameters?.search,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize
      }
    });
  }

  /**
   * Gets all comments of an existing position request by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryPositionRequestComments(
    requestParameters?: QueryPositionRequestCommentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<CommentModel>>;
  public queryPositionRequestComments(
    requestParameters?: QueryPositionRequestCommentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<CommentModel>>>;
  public queryPositionRequestComments(
    requestParameters?: QueryPositionRequestCommentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<CommentModel>>>;
  public queryPositionRequestComments(
    requestParameters?: QueryPositionRequestCommentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const positionRequestId = requestParameters?.positionRequestId;
    this.checkRequired('queryPositionRequestComments', { positionRequestId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/api/v1/master/positions/requests/${this.configuration.encodeParam({ name: 'positionRequestId', value: positionRequestId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/comments`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Queries existing position requests by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryPositionRequests(
    requestParameters?: QueryPositionRequestsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfPositionRequest>;
  public queryPositionRequests(
    requestParameters?: QueryPositionRequestsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfPositionRequest>>;
  public queryPositionRequests(
    requestParameters?: QueryPositionRequestsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfPositionRequest>>;
  public queryPositionRequests(requestParameters?: QueryPositionRequestsParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/api/v1/master/positions/requests`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        PendingApprovalStepName: requestParameters?.pendingApprovalStepName,
        RequestType: requestParameters?.requestType,
        CountryGeoClusterNodeId: requestParameters?.countryGeoClusterNodeId,
        NMinusOneLevelClusterNodeId: requestParameters?.nMinusOneLevelClusterNodeId,
        OrgCode: requestParameters?.orgCode,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        LocationType: requestParameters?.locationType,
        OfficeType: requestParameters?.officeType,
        HiringManagerGid: requestParameters?.hiringManagerGid,
        PositionClass: requestParameters?.positionClass,
        OrgLevel: requestParameters?.orgLevel,
        PositionType: requestParameters?.positionType,
        QueryType: requestParameters?.queryType,
        WorkforceType: requestParameters?.workforceType,
        WorkTimeType: requestParameters?.workTimeType,
        ReferenceNumber: requestParameters?.referenceNumber,
        AreCode: requestParameters?.areCode,
        DepthStructure: requestParameters?.depthStructure,
        CostCenter: requestParameters?.costCenter,
        Country: requestParameters?.country,
        Region: requestParameters?.region,
        StartDate: requestParameters?.startDate,
        EndDate: requestParameters?.endDate
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryReferenceEmployeesEmployeeMasterData(
    requestParameters?: QueryReferenceEmployeesEmployeeMasterDataParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<ReferenceEmployee>>;
  public queryReferenceEmployeesEmployeeMasterData(
    requestParameters?: QueryReferenceEmployeesEmployeeMasterDataParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<ReferenceEmployee>>>;
  public queryReferenceEmployeesEmployeeMasterData(
    requestParameters?: QueryReferenceEmployeesEmployeeMasterDataParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<ReferenceEmployee>>>;
  public queryReferenceEmployeesEmployeeMasterData(
    requestParameters?: QueryReferenceEmployeesEmployeeMasterDataParams,
    ...args: RequestArgs
  ): Observable<any> {
    const orgCode = requestParameters?.orgCode;
    this.checkRequired('queryReferenceEmployeesEmployeeMasterData', { orgCode });
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/api/v1/master/headcount-approval/employee/reference/${this.configuration.encodeParam({ name: 'orgCode', value: orgCode, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { search: requestParameters?.search }
    });
  }

  /**
   * Queries existing countries of a region by specified parameters. Can also query all countries if no region is supplied.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryRegionCountriesCountries(
    requestParameters?: QueryRegionCountriesCountriesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfCountryClusterNode>;
  public queryRegionCountriesCountries(
    requestParameters?: QueryRegionCountriesCountriesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfCountryClusterNode>>;
  public queryRegionCountriesCountries(
    requestParameters?: QueryRegionCountriesCountriesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfCountryClusterNode>>;
  public queryRegionCountriesCountries(
    requestParameters?: QueryRegionCountriesCountriesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/api/v1/master/headcount-approval/countries`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Search: requestParameters?.search,
        RegionIds: requestParameters?.regionIds,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * Queries existing regions by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryRegionsRegions(
    requestParameters?: QueryRegionsRegionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfCluster>;
  public queryRegionsRegions(
    requestParameters?: QueryRegionsRegionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfCluster>>;
  public queryRegionsRegions(
    requestParameters?: QueryRegionsRegionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfCluster>>;
  public queryRegionsRegions(requestParameters?: QueryRegionsRegionsParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/api/v1/master/headcount-approval/regions`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Search: requestParameters?.search, Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * Checks a finished job ad before the position request is submitted.
   * The quality gate behind Submit Request. The job ad is judged as a whole — every block, in every language it is written in — against the instruction its template\&#39;s admin configured plus the agent\&#39;s standing rules, and the answer is one verdict: approved or rejected, a plain-language summary, the improvements to make, and the findings behind them.  &lt;b&gt;Nothing is written and nothing is gated.&lt;/b&gt; The job ad comes back unchanged because it is never touched, and a rejected verdict does not stop a submission — the manager fixes what was found or submits anyway. To keep the verdict with the request, send it back as &#x60;Review&#x60; on that job ad when saving or submitting; only the newest one is stored, and it is what Job Ad Details shows afterwards. One job ad per call: a request matching three templates is three calls, which is also what lets the results appear as they arrive. Send the same documents the prepare transaction produced, including the &#x60;threadId&#x60; it reported for this template — the manager\&#39;s uploaded documents live on that conversation. Refused with a validation error, before the agent is asked anything, when the job ad has not been written yet: it is unfinished rather than poor, and generating it comes first.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public reviewJobAds(
    requestParameters?: ReviewJobAdsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ReviewJobAdResult>;
  public reviewJobAds(
    requestParameters?: ReviewJobAdsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ReviewJobAdResult>>;
  public reviewJobAds(
    requestParameters?: ReviewJobAdsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ReviewJobAdResult>>;
  public reviewJobAds(requestParameters?: ReviewJobAdsParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/customer/api/v1/master/job-ads/review`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.reviewJobAd,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Proxies an AG-UI run to the job ad agent and streams the agent\&#39;s events straight back as server-sent events, so the chat next to the job ad can show the reply while it is still being written.
   * The request body is the AG-UI run input and is forwarded verbatim — the agent owns that contract, and the frontend is the only party that interprets the events coming back. Nothing is read or written here beyond passing the run along.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public streamJobAdAgentRun(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public streamJobAdAgentRun(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public streamJobAdAgentRun(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public streamJobAdAgentRun(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/customer/api/v1/master/headcount-approval/job-ad/ag-ui`,
      accepts: []
    });
  }

  /**
   * Transfers an existing position request to a new organization.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public transferPositionRequest(
    requestParameters?: TransferPositionRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PositionRequest>;
  public transferPositionRequest(
    requestParameters?: TransferPositionRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PositionRequest>>;
  public transferPositionRequest(
    requestParameters?: TransferPositionRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PositionRequest>>;
  public transferPositionRequest(
    requestParameters?: TransferPositionRequestParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('transferPositionRequest', { id });
    return this.sendRequest(args, {
      method: 'post',
      path: `/customer/api/v1/master/positions/requests/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/transfer`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.transferPositionRequest,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Adds one language to a job ad that has already been generated.
   * Send the job ad and its resolved template as they came out of the prepare transaction. The languages the job ad already holds are carried over untouched, and only the blocks the template lets the agent write are translated by it — locked blocks, section headings and building blocks take the wording the template\&#39;s author wrote for that language.  Refused with a validation error, before the agent is asked anything, when the language is not one the template supports or is one the job ad already holds.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public translateJobAds(
    requestParameters?: TranslateJobAdsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TranslateJobAdResult>;
  public translateJobAds(
    requestParameters?: TranslateJobAdsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TranslateJobAdResult>>;
  public translateJobAds(
    requestParameters?: TranslateJobAdsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TranslateJobAdResult>>;
  public translateJobAds(requestParameters?: TranslateJobAdsParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/customer/api/v1/master/job-ads/translate`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.translateJobAd,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Updates an existing job description.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateJobDescriptions(
    requestParameters?: UpdateJobDescriptionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<JobDescription>;
  public updateJobDescriptions(
    requestParameters?: UpdateJobDescriptionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<JobDescription>>;
  public updateJobDescriptions(
    requestParameters?: UpdateJobDescriptionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<JobDescription>>;
  public updateJobDescriptions(requestParameters?: UpdateJobDescriptionsParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updateJobDescriptions', { id });
    return this.sendRequest(args, {
      method: 'put',
      path: `/customer/api/v1/master/job-descriptions/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateJobDescription,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Updates an existing position request draft by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updatePositionRequestDrafts(
    requestParameters?: UpdatePositionRequestDraftsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PositionRequestDraft>;
  public updatePositionRequestDrafts(
    requestParameters?: UpdatePositionRequestDraftsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PositionRequestDraft>>;
  public updatePositionRequestDrafts(
    requestParameters?: UpdatePositionRequestDraftsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PositionRequestDraft>>;
  public updatePositionRequestDrafts(
    requestParameters?: UpdatePositionRequestDraftsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updatePositionRequestDrafts', { id });
    return this.sendRequest(args, {
      method: 'put',
      path: `/customer/api/v1/master/positions/requests/drafts/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updatePositionRequestDraft,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Updates an existing position request plan by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updatePositionRequestPlan(
    requestParameters?: UpdatePositionRequestPlanParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PositionRequestDraft>;
  public updatePositionRequestPlan(
    requestParameters?: UpdatePositionRequestPlanParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PositionRequestDraft>>;
  public updatePositionRequestPlan(
    requestParameters?: UpdatePositionRequestPlanParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PositionRequestDraft>>;
  public updatePositionRequestPlan(
    requestParameters?: UpdatePositionRequestPlanParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updatePositionRequestPlan', { id });
    return this.sendRequest(args, {
      method: 'put',
      path: `/customer/api/v1/master/positions/requests/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updatePositionRequestPlan,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Creates a new position request (as a \&#39;create from draft by its unique id\&#39;) or updates an existing position request by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updatePositionRequests(
    requestParameters?: UpdatePositionRequestsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PositionRequest>;
  public updatePositionRequests(
    requestParameters?: UpdatePositionRequestsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PositionRequest>>;
  public updatePositionRequests(
    requestParameters?: UpdatePositionRequestsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PositionRequest>>;
  public updatePositionRequests(
    requestParameters?: UpdatePositionRequestsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updatePositionRequests', { id });
    return this.sendRequest(args, {
      method: 'put',
      path: `/customer/api/v1/master/positions/requests/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updatePositionRequest,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Validates the position class, career level and career stream of a position request against the head position of the org code the position is requested for.
   * Meant to be called while the request dialog is open, whenever the org code, the job code or the position class changes. Blocking messages are enforced again on create and update.  Returns 400 when the org code is outside the requester\&#39;s jurisdiction, the same way creating or updating the request would. That is not a validation message, so there is nothing to display at a field for it.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public validatePositionRequests(
    requestParameters?: ValidatePositionRequestsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PositionRequestValidationResponse>;
  public validatePositionRequests(
    requestParameters?: ValidatePositionRequestsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PositionRequestValidationResponse>>;
  public validatePositionRequests(
    requestParameters?: ValidatePositionRequestsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PositionRequestValidationResponse>>;
  public validatePositionRequests(
    requestParameters?: ValidatePositionRequestsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/customer/api/v1/master/positions/requests/validate`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.validatePositionRequestInputQuery,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Vetos an existing position request by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public vetoPositionRequests(
    requestParameters?: VetoPositionRequestsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PositionRequest>;
  public vetoPositionRequests(
    requestParameters?: VetoPositionRequestsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PositionRequest>>;
  public vetoPositionRequests(
    requestParameters?: VetoPositionRequestsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PositionRequest>>;
  public vetoPositionRequests(requestParameters?: VetoPositionRequestsParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('vetoPositionRequests', { id });
    return this.sendRequest(args, {
      method: 'post',
      path: `/customer/api/v1/master/positions/requests/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/veto`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }
}
